module.exports = __webpack_public_path__ + "static/tickster-results-8e77209f49f0039bf20b4ddb94722740.jpg";